import React from "react";
import { motion } from "framer-motion";
import { Calendar, Users, Lock } from "lucide-react";

const Pricing = () => {
  return (
    <section id="pricing" className="py-20 md:py-28 bg-[#F5F5F0]">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mx-auto text-center mb-12"
        >
          <p className="text-sm uppercase tracking-[0.2em] font-semibold text-[#C9A227] mb-4">
            Working With Us
          </p>
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-medium text-[#1A202C] tracking-tight mb-6"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            A Personalised <span className="text-[#2B4C7E]">Engagement</span>
          </h2>
          <p className="text-lg text-[#4A5568] leading-relaxed">
            Every family's situation is unique. Our engagement structure reflects
            this reality.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="max-w-2xl mx-auto bg-white rounded-[4px] border border-[#E2E8F0] p-8 md:p-12"
        >
          <div className="space-y-8">
            {/* Step 1 */}
            <div className="flex gap-6">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 rounded-full bg-[#2B4C7E]/10 flex items-center justify-center">
                  <Calendar className="w-6 h-6 text-[#2B4C7E]" />
                </div>
              </div>
              <div>
                <h3
                  className="text-xl font-medium text-[#1A202C] mb-2"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  Diagnostic Strategy Call
                </h3>
                <p className="text-[#4A5568] leading-relaxed">
                  We begin with a complimentary 30-minute call to understand your
                  family's goals, your child's profile, and the scope of support
                  you need.
                </p>
              </div>
            </div>

            {/* Step 2 */}
            <div className="flex gap-6">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 rounded-full bg-[#2B4C7E]/10 flex items-center justify-center">
                  <Users className="w-6 h-6 text-[#2B4C7E]" />
                </div>
              </div>
              <div>
                <h3
                  className="text-xl font-medium text-[#1A202C] mb-2"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  Tailored Plan & Investment
                </h3>
                <p className="text-[#4A5568] leading-relaxed">
                  Based on our conversation, we propose a customised advisory plan
                  with transparent pricing — aligned with the services and timeline
                  you require.
                </p>
              </div>
            </div>

            {/* Step 3 */}
            <div className="flex gap-6">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 rounded-full bg-[#C9A227]/20 flex items-center justify-center">
                  <Lock className="w-6 h-6 text-[#C9A227]" />
                </div>
              </div>
              <div>
                <h3
                  className="text-xl font-medium text-[#1A202C] mb-2"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  Limited Monthly Intake
                </h3>
                <p className="text-[#4A5568] leading-relaxed">
                  To ensure each family receives dedicated attention, we limit the
                  number of new engagements we accept each month.
                </p>
              </div>
            </div>
          </div>

          {/* Note */}
          <div className="mt-10 pt-8 border-t border-[#E2E8F0]">
            <p className="text-center text-[#4A5568] italic">
              We do not publish standard pricing because no two families have
              identical needs. Our commitment is to provide exceptional value,
              tailored to your specific situation.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Pricing;
